<nav class="navbar navbar-expand-md light">
  <div class="container-fluid">

    <app-hamburger-button></app-hamburger-button>

    <a class="navbar-brand" routerLink="/main">
      <img src="assets/images/logo-full-black.svg" alt="Bulgari Catalogo">
    </a>

    <ul class="navbar-nav">

      <li class="nav-item user-and-store">

        <span> {{authService.user?.name?.toUpperCase()}}</span>
        <img src="assets/icons/mybulgari-black.svg" alt="">

        @if(authService.user?.isUserStore){
        <span> {{authService.store?.nameStore?.toUpperCase()}}</span>
        }@else {
        {{authService.user?.role?.toUpperCase()}}
        }

      </li>
      @if(tecService.isTermsAndConditionConfirmed()){
      <div class="vr"></div>
      <li class="nav-item">
        <a class="nav-link search" aria-current="page" routerLink="/main/search" routerLinkActive="active">
          <i class="bi bi-search"></i>
        </a>
      </li>
      }
    </ul>

  </div>
</nav>
